module.exports = __webpack_public_path__ + "static/img/Monitor.7d56dba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Monitor.png
// module id = jUFx
// module chunks = 0